import { render, staticRenderFns } from "./AccountDisableRequestList.vue?vue&type=template&id=4e4373f9&scoped=true&"
import script from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
export * from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
import style0 from "./AccountDisableRequestList.vue?vue&type=style&index=0&id=4e4373f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4373f9",
  null
  
)

export default component.exports